import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CategoryOfPortfolioPage = () => {
  const [categories, setCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const getData = (count = 5, offset = 0) => {
    apiRequests.portfolio.getCategories(count, offset).then(setCategories);
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.portfolio.getCategoriesFiltered(searchValue).then(setCategories);
    }
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = (id) => {
    apiRequests.portfolio.deleteCategory(id).then((res) => {
      setCategories((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      }));
    });
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink="/portfolio/categories/create"
      />

      <div className="mb-3">
        {categories.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          categories.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`/portfolio/categories/${item.id}`}
              localizationLink={`/portfolio/categories/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={categories.totalCount}
        itemsPerPage={5}
        onChange={(page) => getData(5, 5 * page)}
      />
    </>
  );
};

export default CategoryOfPortfolioPage;
